import { Controller } from 'stimulus'

export default class extends Controller {
  static get targets() {
    return ['radio', 'hidden', 'shown']
  }

  connect() {
    this.toggleTargets()
  }

  toggleTargets() {
    const checked =
      this.radioTarget.querySelector('input:checked').value == 'true'
    this.hiddenTargets?.forEach((el) => {
      el.hidden = !checked
    })
    this.shownTargets?.forEach((el) => {
      el.hidden = checked
    })
  }
}
